import React from "react";
import "./OwLabel.scss";
import { FormattedMessage, useIntl } from "react-intl";
import * as _ from "lodash-es";
import IOwLabelProps from "./IOwLabelProps";

type Props = IOwLabelProps & {
    for?: string;
    className?: string;
    leftIconClass?: string;
    leftIconTitle?: string;
    rightIconClass?: string;
    title?: string;
    description?: string;
    isSupplierVendorOverride?: boolean;
    supplierModel?: any;
    isBold?: boolean;
    isItalic?: boolean;
    isUnderline?: boolean;
    internalComponent?: any;
    showIsReqAsterik?: boolean;
    noBottomMargin?: boolean;
    rowHasSort?: boolean; // if the row the label is on has using OwSortHeader
    isUppercase?: boolean;
    isLowercase?: boolean;
    fn?: (title: string) => void;
    skipTranslate?: boolean;
    tabIndex?: number;
    postText?: string;
    preText?: string;
    skipFnClassNames?: boolean;
    role?: string;
};

export const OwLabel = (props: Props) => {
    const intl = useIntl();

    let title: any = props.title || "";

    if (props.isSupplierVendorOverride && !_.isNil(props.supplierModel)) {
        if (!_.isNil(props.supplierModel.vendor_name_override)) {
            title = title.replace(/vendor/g, props.supplierModel.vendor_name_override);
        }
    }

    if (title.length && !props.skipTranslate) {
        title = <FormattedMessage id={title} defaultMessage={`_${title}_`} description={props.description} />;
    }

    let leftIconClass = "";

    if (props.leftIconClass) {
        leftIconClass = props.leftIconClass + " me-2";
    }

    let rightIconClass = "";

    if (props.rightIconClass) {
        rightIconClass = props.rightIconClass + " ms-2";
    }

    let leftIconTitle: string | undefined;

    if (props.leftIconTitle) {
        leftIconTitle = intl.formatMessage({ id: props.leftIconTitle });
    }

    let middleContent = (
        <React.Fragment>
            {leftIconClass.length ? <i role={"left-icon"} className={leftIconClass} title={leftIconTitle} /> : null}
            {title}
            {rightIconClass.length ? <i role={"right-icon"} className={rightIconClass} /> : null}
        </React.Fragment>
    );

    if (!_.isNil(props.internalComponent)) {
        middleContent = (
            <React.Fragment>
                {props.internalComponent} <i role={"middle-icon"} className={leftIconClass} /> {title} <i className={rightIconClass} />
            </React.Fragment>
        );
    }

    if (props.isUnderline) {
        middleContent = <u>{middleContent}</u>;
    }

    let content = (
        <>
            {props.preText}
            {middleContent}
            {props.postText}
        </>
    );

    if (props.showIsReqAsterik) {
        content = (
            <span>
                {content}
                <span className={"text-danger"}>*</span>
            </span>
        );
    }

    if (props.isBold) {
        content = <b>{content}</b>;
    }

    if (props.isItalic) {
        content = <i>{content}</i>;
    }

    if (props.isUppercase) {
        content = <span className={"text-uppercase"}>{content}</span>;
    }

    if (props.isLowercase) {
        content = <span className={"text-lowercase"}>{content}</span>;
    }

    const finalLabel = (
        <label
            role={props.role}
            htmlFor={props.for}
            tabIndex={props.tabIndex}
            onClick={() => {
                if (props.fn) {
                    props.fn(props.title || "");
                }
            }}
            className={
                "OwLabel " +
                (props.rowHasSort ? "hasRowSort" : "") +
                " " +
                (props.className || "") +
                " " +
                (props.noBottomMargin ? "mb-0" : "") +
                " " +
                (props.fn && !props.skipFnClassNames ? "pointer text-primary" : "")
            }>
            {content}
        </label>
    );

    return finalLabel;
};

export default OwLabel;
